import { z } from "zod";

export const localeSchema = z.enum([
	"cs",
	"da-DK",
	"de-DE",
	"en",
	"es-419",
	"es-ES",
	"fl",
	"fr-CA",
	"fr-FR",
	"hu-HU",
	"it-IT",
	"nl-NL",
	"pl-PL",
	"pt",
	"ro-RO",
	"sk-SK",
	"sv-SE",
]);

export const supportedLocales = localeSchema.options;

export type Locale = z.infer<typeof localeSchema>;

export const createLocaleSchema = <const T extends readonly Locale[]>(values: T) => z.enum(values);
